export class Link {
  rel: string;
  href: string;
}